module.exports = __webpack_public_path__ + "static/img/weather31.9afb459a.png";